import './App.css';

import ToolTip from './Components/ToolTip/ToolTip';

function App() {
  return (
    <div className="App">
      <ToolTip />
    </div>
  );
}

export default App;
